export default function CTASplitSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex flex-col md:flex-row rounded-3xl overflow-hidden bg-background-50">
          <div className="md:w-1/2 relative min-h-[360px] md:min-h-[500px]">
            <img
              src="https://readdy.ai/api/search-image?query=Diverse%20fashion%20and%20lifestyle%20products%20grid%20photography%20with%20shoes%20bags%20clothing%20and%20accessories%20neatly%20organized%20on%20light%20grey%20surface%20against%20white%20wall%20bright%20studio%20lighting%20clean%20catalog%20style%20editorial&width=900&height=1100&seq=cta-v2-split-z01&orientation=portrait"
              alt="itaobuy sheet product catalog"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-black/20"></div>
            <div className="absolute top-0 left-0 p-6 md:p-8">
              <span className="text-background-50/80 text-xs font-semibold uppercase tracking-wider">
                Trusted by Global Buyers
              </span>
            </div>
            <div className="absolute bottom-0 left-0 p-6 md:p-8">
              <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-none">
                Start
              </h2>
              <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-none">
                Your
              </h2>
              <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-none">
                Sourcing
              </h2>
            </div>
          </div>

          <div className="md:w-1/2 flex flex-col justify-center items-center text-center p-8 md:p-12 lg:p-16">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-4">
              Join the Sourcing Revolution
            </h2>
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed max-w-[420px] mb-8">
              The <strong>itaobuy spreadsheet</strong> system is changing how global buyers source from China. Faster processing, lower costs, and complete transparency in one streamlined platform.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-foreground-900 text-background-50 text-sm md:text-base font-semibold cursor-pointer hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap"
            >
              Buy It Now on Kaspreadsheet
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-up-line"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}